export const letterSpacings = {
  tighter: '-0.01rem',
  tight: '-0.005rem',
  normal: '0rem',
};
